<!-- host styling is in dialog.component.scss -->

<div class="flex justify-between items-center gap-8">
  <div class="flex gap-4 items-center">
    <i class="icon-close_m p-2 cursor-pointer text-2xl" (click)="closeRequested.emit()"></i>
    <h3>{{ dialogTitle | translate }}</h3>
    <ng-content select="[dialogAdditionalHeaderPart]"></ng-content>
  </div>
  <div class="flex gap-2 p-2">
    <ng-content select="[dialogActions]"></ng-content>
  </div>
</div>

@if(!customLayout) {
  <hd-card class="flex-1 overflow-y-auto" borderType="standout">
    <ng-content select="[dialogContent]"></ng-content>
  </hd-card>
} @else {
  <ng-content select="[customDialogLayoutContent]"></ng-content>
}
